@if (current(); as cur) {
  @if (multi()) {
    <button
      mat-stroked-button
      type="button"
      class="sport-switcher__btn"
      [matMenuTriggerFor]="sportMenu"
      [matTooltip]="cur.rulesSummary"
      matTooltipPosition="below"
      aria-label="Switch sport"
    >
      <mat-icon>{{ cur.icon }}</mat-icon>
      <span class="sport-switcher__label">{{ cur.label }}</span>
      <mat-icon class="sport-switcher__chev">expand_more</mat-icon>
    </button>

    <mat-menu #sportMenu="matMenu" xPosition="before">
      @for (s of available(); track s.key) {
        <button
          mat-menu-item
          type="button"
          (click)="select(s.key)"
          [matTooltip]="s.rulesSummary"
          matTooltipPosition="left"
          [attr.aria-current]="s.key === cur.key ? 'true' : null"
        >
          <mat-icon>{{ s.icon }}</mat-icon>
          <span>{{ s.label }}</span>
        </button>
      }
    </mat-menu>
  } @else {
    <span class="sport-switcher__solo" [matTooltip]="cur.rulesSummary" matTooltipPosition="below">
      <mat-icon>{{ cur.icon }}</mat-icon>
      <span class="sport-switcher__label">{{ cur.label }}</span>
    </span>
  }
}
